import { getEntityRef } from "@client/content/lib/helper";
import { type EntityRef } from "@client/types";
import * as React from "react";
import Search from "./Search/container";

export type MapProps = EntityRef & {
  isSearchVisible: boolean;
  isTitleVisible: boolean;
  title: string;
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) =>
  props.isTitleVisible || props.isSearchVisible ? (
    <div className={"top_bar"}>
      <h3 className="title">{props.isTitleVisible ? props.title : ""}</h3>
      {props.isSearchVisible && (
        <div className="actions">
          <Search {...getEntityRef(props)} />
        </div>
      )}
    </div>
  ) : null;
